import { render, staticRenderFns } from "./paperReport.vue?vue&type=template&id=2142aed9&scoped=true"
import script from "./paperReport.vue?vue&type=script&lang=js"
export * from "./paperReport.vue?vue&type=script&lang=js"
import style0 from "./paperReport.vue?vue&type=style&index=0&id=2142aed9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2142aed9",
  null
  
)

export default component.exports